import type { PropsWithChildren } from "react";
import { PixelPlaceholderLoader } from "@similarweb/ui-components";

export const WrappedWithPreloader = ({
    isLoading,
    children,
    width = 10,
    height = 10,
}: PropsWithChildren<{ isLoading: boolean; width?: number | string; height?: number }>) => {
    return isLoading ? (
        <PixelPlaceholderLoader
            width={width}
            height={height}
        />
    ) : (
        <>{children}</>
    );
}
